import { useEffect, useState } from 'react';
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Spinner,
  Button,
} from '@nextui-org/react';
import ModalTask from '../components/tasks/modalTask/modalTask';
import { Tasks } from 'common/src/utils/types'; // Import the Tasks type
import { fetchTaskRecurrents } from 'common/src/api/tasks';

// Update the RecurringTask type to extend Tasks
type RecurringTask = Tasks & {
  task_offers: { tasker_id: number }[] | null;
  is_asap: boolean;
  is_flexible_date: boolean;
};

export default function RecurringTasksPage() {
  const [tasks, setTasks] = useState<RecurringTask[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedTask, setSelectedTask] = useState<RecurringTask | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchRecurringTasks();
  }, []);

  async function fetchRecurringTasks() {
    try {
      const { data, error } = await fetchTaskRecurrents()

      if (error) throw error;

      setTasks(data as RecurringTask[]);
    } catch (error) {
      console.error('Error fetching recurring tasks:', error);
    } finally {
      setLoading(false);
    }
  }

  function formatDate(
    date: string | null,
    isAsap: boolean,
    isFlexible: boolean
  ): string {
    if (isAsap) return 'Lo antes posible';
    if (isFlexible) return 'Fecha flexible';
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('es-CL');
  }

  const handleOpenModal = (task: RecurringTask) => {
    setSelectedTask(task);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedTask(null);
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Tasks Recurrentes</h1>
      {loading ? (
        <Spinner label="Cargando..." />
      ) : (
        <Table aria-label="Tabla de tasks recurrentes">
          <TableHeader>
            <TableColumn>ID</TableColumn>
            <TableColumn>ID del Asker</TableColumn>
            <TableColumn>ID del Tasker</TableColumn>
            <TableColumn>Fecha</TableColumn>
            <TableColumn>Categoría</TableColumn>
            <TableColumn>Descripción</TableColumn>
            <TableColumn>Acciones</TableColumn>
          </TableHeader>
          <TableBody>
            {tasks.map((task) => (
              <TableRow key={task.id}>
                <TableCell>{task.id}</TableCell>
                <TableCell>{task.asker_id}</TableCell>
                <TableCell>
                  {task.task_offers && task.task_offers.length > 0
                    ? task.task_offers[0].tasker_id
                    : 'N/A'}
                </TableCell>
                <TableCell>
                  {formatDate(task.date, task.is_asap, task.is_flexible_date)}
                </TableCell>
                <TableCell>{task.category}</TableCell>
                <TableCell>{task.description}</TableCell>
                <TableCell>
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={() => handleOpenModal(task)}
                  >
                    Ver detalles
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {selectedTask && (
        <ModalTask
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          task={selectedTask} // Now this should match the expected type
          onReset={handleCloseModal}
          fetchTasks={fetchRecurringTasks}
        />
      )}
    </div>
  );
}
